import React from "react";
import { useLocation } from "react-router-dom";

const PolicyPaperPreview = () => {
  const location = useLocation();
  let { state } = location;
  return (
    <>
      <embed
        // src={`data:application/pdf;base64,${previewPDF}`}
        src={state}
        type="application/pdf"
        className="web-device"
        style={{ width: "100%", height: "100vh" }}
      />
    </>
  );
};

export default PolicyPaperPreview;
